import React, { useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signInWithEmailAndPassword
} from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../../utils/firebase";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where
} from "firebase/firestore";
import { collectionNames, routes } from "../../utils/Constants";

const Login = () => {
  const navigate = useNavigate();
  const { state } = useLocation() ?? {};
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfimPwd] = useState("");
  const [authSet, setAuthSet] = useState(); // stores about password set or not
  const [user, setUser] = useState();

  const loginHandler = async () => {
    signInWithEmailAndPassword(auth, email, pwd)
      .then((userCredential) => {
        const user = userCredential.user;

        navigate("/");
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        alert(error.message);
      });
  };

  const signUpHandler = async () => {
    if (!email || !pwd) return alert("Fill All details");
    if (pwd != confirmPwd) return alert("Passwords doesnt match");

    await createUserWithEmailAndPassword(auth, email, pwd)
      .then(async (userCredential) => {
        const docRef = await updateDoc(
          doc(db, collectionNames.STAFFS, user.id),
          {
            authSet: true
          }
        );
        navigate("/");

        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        alert(error.message);
      });
  };

  //  password created or not checking.
  const checkIfAuthSet = async () => {
    if (!email) return alert("Enter email to continue");
    const q = query(collection(db, "Staffs"), where("email", "==", email));

    const querySnapshot = await getDocs(q);
    if (querySnapshot.size == 0) return alert("Email not exist");

    querySnapshot.forEach((doc) => {
      if (doc.data().authSet) {
        setAuthSet(true);
      } else {
        setUser({ id: doc.id });
        setAuthSet(false);
      }
    });
  };

  //send meail to reset password.
  const triggerPwdResetEmail = async () => {
    await sendPasswordResetEmail(auth, email);
    alert(
      "Password reset link sent to your email successfully. If you don't see the email in your inbox after 2 minutes , also check your spam folder."
    );
  };

  //check if user disabled or not.
  useEffect(() => {
    if (state?.disabled) {
      alert("User disabled by admin");
    }
  }, []);

  return (
    <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
      <div className="w-full p-6 m-auto bg-white rounded-md shadow-md lg:max-w-lg">
        <h1 className="text-3xl font-semibold text-center text-primary underline">
          Sign in
        </h1>
        <div className="mt-6">
          <div className="mb-2">
            <label
              for="email"
              className="block text-sm font-semibold text-gray-800"
            >
              Email
            </label>
            <input
              type="email"
              className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {authSet != undefined && (
            <div className="mb-2">
              <label
                for="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Password
              </label>
              <input
                type="password"
                className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
                onChange={(e) => setPwd(e.target.value)}
              />
            </div>
          )}
          {authSet == false && (
            <div className="mb-2">
              <label
                for="password"
                className="block text-sm font-semibold text-gray-800"
              >
                Confirm Password
              </label>
              <input
                type="password"
                className="block w-full px-4 py-2 mt-2 text-purple-700 bg-white border rounded-md focus:border-purple-400 focus:ring-purple-300 focus:outline-none focus:ring focus:ring-opacity-40"
                onChange={(e) => setConfimPwd(e.target.value)}
              />
            </div>
          )}
          {authSet == true && (
            <a
              href="#"
              className="text-xs text-primary hover:underline"
              onClick={triggerPwdResetEmail}
            >
              Forgot Password?
            </a>
          )}
          <div className="mt-6">
            <button
              onClick={() =>
                authSet == undefined
                  ? checkIfAuthSet()
                  : authSet
                  ? loginHandler()
                  : signUpHandler()
              }
              className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-primary rounded-md hover:bg-background focus:outline-none focus:bg-primary"
            >
              {authSet == undefined ? "Continue" : " Login"}
            </button>
          </div>
        </div>
        <p class="text-center text-sm mt-3">
          Not registered yet?{" "}
          <span
            class="text-primary cursor-pointer"
            onClick={() => navigate(routes.SIGNUP)}
          >
            Sign Up
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
